import React from 'react';
import App from './app';

const AppWrapper = (props) => {
  const { modalOpened } = props;
  return (<>{ modalOpened && <App { ...props } /> }</>);
};

export default AppWrapper;
